export default __webpack_public_path__ + "static/media/unlink-icon.0f1d399e.svg";